<template>
  <v-main>
    <v-container fluid class="py-15">
      <v-card class="pa-3 mx-auto" max-width="500">
        <v-img
          v-if="branding && branding.logoUrl"
          class="mx-auto"
          :src="branding.logoUrl"
          :alt="branding.portalName"
          max-width="190"
          max-height="75"
        />
        <v-card-title
          v-if="branding && !branding.logoUrl && branding.portalName"
          class="d-flex flex-column align-center"
        >
          <sf-title ref="no-logo-fallback" class="font-weight-bold">
            {{ branding.portalName }}
          </sf-title>
        </v-card-title>
        <v-card-text>
          <sf-heading>{{ $t('essentialShopDeactivated.descriptionTitle') }}</sf-heading>
          <br />
          <br />
          <sf-text>{{ $t('essentialShopDeactivated.descriptionStart') }}</sf-text>
          <ul class="d-flex flex-column my-2 ml-2">
            <li>
              <sf-text>{{ $t('essentialShopDeactivated.descriptionPoint1') }}</sf-text>
            </li>
            <li>
              <sf-text>{{ $t('essentialShopDeactivated.descriptionPoint2') }}</sf-text>
            </li>
            <li>
              <sf-text>{{ $t('essentialShopDeactivated.descriptionPoint3') }}</sf-text>
            </li>
            <li>
              <sf-text>{{ $t('essentialShopDeactivated.descriptionPoint4') }}</sf-text>
            </li>
          </ul>
          <sf-text class="font-weight-bold">{{
            $t('essentialShopDeactivated.descriptionEnd')
          }}</sf-text>
          <br /><br />
        </v-card-text>
        <sf-large-button block @click="showRequestDialog = true">{{
          $t('essentialShopDeactivated.requestActivation')
        }}</sf-large-button>
        <request-essential-shop-activation-dialog v-model="showRequestDialog" />
      </v-card>
    </v-container>
  </v-main>
</template>

<script setup lang="ts">
import SfHeading from '@/components/text/SfHeading.vue'
import SfText from '@/components/text/SfText.vue'
import SfLargeButton from '@/components/button/SfLargeButton.vue'
import SfTitle from '@/components/text/SfTitle.vue'
import RequestEssentialShopActivationDialog from '@/modules/essentialShop/components/RequestEssentialShopActivationDialog.vue'
import { useTitle } from '@/helpers'
import useBranding from '@/modules/portalSettings/useBranding'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { branding } = useBranding()

const { t } = useI18n()

useTitle(ref(t('essentialShopDeactivated.pageTitle')))

const showRequestDialog = ref(false)
</script>
